class ClosestRelatedCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const container = this.querySelector('.swiper');
    if (!container) return;

    // Parse settings
    const autoplayData = this.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(this.dataset.autoplayDelay) || 3000;
    const loop = this.dataset.loop === 'true';
    const slidesDesktop = parseFloat(this.dataset.slidesDesktop) || 4;
    const slidesTablet = parseFloat(this.dataset.slidesTablet) || 3;
    const slidesMobile = parseFloat(this.dataset.slidesMobile) || 1.5;
    const gap = parseInt(this.dataset.gap) || 20;

    const swiperOptions = {
        slidesPerView: slidesMobile,
        spaceBetween: gap,
        loop: loop,
        navigation: {
          nextEl: this.closest('.section-closest-carousel__container').querySelector('.section-closest-carousel__next'),
          prevEl: this.closest('.section-closest-carousel__container').querySelector('.section-closest-carousel__prev'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: slidesTablet,
          },
          1024: {
            slidesPerView: slidesDesktop,
          }
        },
        on: {
          init: () => {
             this.revealCards();
          }
        }
    };

    if (autoplayData) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    // Initialize Swiper
    // Assuming Swiper is globally available or we need to wait for it.
    // Ideally, the theme loads it. If checks are needed:
    if (typeof Swiper !== 'undefined') {
      this.swiperInstance = new Swiper(container, swiperOptions);
    } else {
      // Fallback or lazy load swiper if needed, but assuming theme has it as per analysis
      console.warn('Swiper not defined');
    }

    this.initAddToCart();
  }

  revealCards() {
     const cards = this.querySelectorAll('.closest-card');
     cards.forEach((card, index) => {
        setTimeout(() => {
           card.classList.add('animate-in');
        }, index * 100);
     });
  }

  initAddToCart() {
    const atcButtons = this.querySelectorAll('.js-closest-atc');
    
    atcButtons.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const card = btn.closest('.closest-card');
        const variantId = btn.dataset.variantId;
        const qtyInput = card.querySelector('.js-closest-qty');
        const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

        if (!variantId) return;

        btn.classList.add('loading');
        
        try {
          const formData = {
            'items': [{
              'id': variantId,
              'quantity': quantity
            }]
          };

          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });

          if (response.ok) {
             // Dispatch event for theme drawer/notification
             // Many themes listen for 'cart:updated' or similar
             document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));
             // Also try standard shopify ajax events if theme uses them
             document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true}));
             
             // Simple visual feedback if theme doesn't catch it
             const originalText = btn.innerHTML;
             btn.innerHTML = '✔';
             setTimeout(() => btn.innerHTML = originalText, 2000);
          } else {
             console.error('Error adding to cart');
          }
        } catch (error) {
          console.error(error);
        } finally {
          btn.classList.remove('loading');
        }
      });
    });

    // Quantity selectors
    const qtyBtns = this.querySelectorAll('.js-closest-qty-btn');
    qtyBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
         e.preventDefault();
         const isPlus = btn.dataset.action === 'plus';
         const input = btn.closest('.closest-card__qty-control').querySelector('.js-closest-qty');
         let val = parseInt(input.value);
         if (isPlus) val++;
         else val = val > 1 ? val - 1 : 1;
         input.value = val;
      });
    });
  }
}

customElements.define('closest-related-carousel', ClosestRelatedCarousel);
